'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Slideshow = function (_Component) {
  (0, _inherits3.default)(Slideshow, _Component);

  // The way transitions are set up they don't work for two images hence the repetition of images in state.images
  function Slideshow(props) {
    (0, _classCallCheck3.default)(this, Slideshow);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Slideshow.__proto__ || (0, _getPrototypeOf2.default)(Slideshow)).call(this, props));

    _this.state = {
      images: props.images,
      active: [],
      i: 0
    };

    return _this;
  }

  (0, _createClass3.default)(Slideshow, [{
    key: 'kenburns',
    value: function kenburns() {
      var _state = this.state,
          images = _state.images,
          active = _state.active;
      var i = this.state.i;


      var numberOfImages = images.length;
      if (i == numberOfImages) i = 0;

      active[i] = true;

      // we can't remove the class from the previous element or we'd get a bouncing effect so we clean up the one before last
      // (there must be a smarter way to do this though)
      if (i === 0) {
        active[numberOfImages - 2] = false;
      }
      if (i === 1) {
        active[numberOfImages - 1] = false;
      }
      if (i > 1) {
        active[i - 2] = false;
      }

      i++;

      this.setState({ i: i, active: active });

      this.timeout = window.setTimeout(this.kenburns, this.props.duration);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var images = this.state.images;

      var active = images.map(function (img, i) {
        return false;
      });

      this.kenburns = this.kenburns.bind(this);

      // Fix for first image not animating
      this.timeout = window.setTimeout(this.kenburns, this.props.duration);

      this.setState({ active: active });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: 'render',
    value: function render() {
      var _state2 = this.state,
          images = _state2.images,
          active = _state2.active;

      var styles = require('./Slideshow.scss');
      var fx = this.props.zoom ? styles.zoom : styles.nozoom;

      return _react2.default.createElement(
        'div',
        { className: styles['slideshow-container'] },
        _react2.default.createElement(
          'div',
          { className: styles.slideshow },
          images.map(function (img, i) {
            var cn = '';
            if (active[i]) cn = fx;

            return _react2.default.createElement('img', { className: cn, key: i, src: img });
          })
        )
      );
    }
  }]);
  return Slideshow;
}(_react.Component); /* eslint-disable */

Slideshow.defaultProps = {
  duration: 2000,
  zoom: true
};

exports.default = Slideshow;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Slideshow/Slideshow.jsx
// module id = 2727
// module chunks = 0